import { render } from "./WeeklyExpensesChart.vue?vue&type=template&id=4a1c0124&ts=true"
import script from "./WeeklyExpensesChart.vue?vue&type=script&lang=ts"
export * from "./WeeklyExpensesChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__